import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/**
 * ContactBar component that displays contact information in the header
 * Currently showing only email, with address and phone hidden for future use
 */
const ContactBar = () => {
    const { theme } = useTheme();
    // Email in the header has been intentionally removed per user request
    return null;
};

export default ContactBar;